import { render, staticRenderFns } from "./DossierIdentification.vue?vue&type=template&id=b6009700&scoped=true&"
import script from "./DossierIdentification.vue?vue&type=script&lang=js&"
export * from "./DossierIdentification.vue?vue&type=script&lang=js&"
import style0 from "./DossierIdentification.vue?vue&type=style&index=0&id=b6009700&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6009700",
  null
  
)

export default component.exports